export enum ContextMenu {
  NewTab = 'newTab',
}

export const getContextMenuList = (): CommonList[] => {
  return [
    {
      id: ContextMenu.NewTab,
      label: 'Open in new tab',
    },
  ];
};
